import { useSearchParams } from "react-router";
import Cookies from "js-cookie";

export function useExperimentOverride(): string | undefined {
  const [searchParams] = useSearchParams();
  const cookieExperiments = Cookies.get("experiment") ?? "";
  const paramExperiments = searchParams.get("backendExperiments") ?? "";

  if (cookieExperiments && paramExperiments) {
    return cookieExperiments + "," + paramExperiments;
  } else if (cookieExperiments) {
    return cookieExperiments;
  } else if (paramExperiments) {
    return paramExperiments;
  } else {
    return undefined;
  }
}
